import { useNavigate } from 'react-router-dom';
import MuiDataTable from 'components/mui-data-table/mui-data-table';
import { transactionColumns } from 'features/transactions/hooks';
import { noRowsTitle, usePermissionChecker } from 'utils/utils';
import { useGateway } from 'hooks';

export function TransactionsDataTable({
    transactionData,
    isHeaderDark,
    isDashboard,
}: {
    transactionData: any;
    isHeaderDark?: boolean;
    isDashboard?: boolean;
}) {
    const navigate = useNavigate();
    const { hasPermission } = usePermissionChecker();
    const active = useGateway();

    const {
        rowsData,
        isLoadingData,
        isSuccessData,
        search,
        setPage,
        paginateInfo,
        refetch,
    } = transactionData;

    const columns = transactionColumns;

    if (!active) return <></>;

    const isPermissionTrue: boolean = hasPermission(
        'gateway-transaction-detail',
    );

    return (
        <MuiDataTable
            rows={rowsData}
            columns={columns}
            isLoading={isLoadingData}
            isSuccess={isDashboard ?? isSuccessData}
            onRefetch={active?.status === 'activated' ? refetch : undefined}
            paginateInfo={paginateInfo}
            setPage={setPage}
            onClickFunction={
                isPermissionTrue
                    ? (params) =>
                          navigate(
                              `/${active.website}/transaction/${params.id}`,
                          )
                    : undefined
            }
            noRowsMessage={noRowsTitle('تراکنشی', search)}
            headerStyle={isHeaderDark ? 'dark' : 'light'}
        />
    );
}
